import { nativeLinkedInConditions } from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-linkedin-ad";
import { IPlacementsConfiguration } from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
import { IXandrNativeAdObject } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { StackContext } from "../context";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";

const sizes: { [key: string]: [number, number][] } = {
  parade1: [
    [1170, 400],
    [980, 600],
    [980, 400],
    [980, 552],
    [980, 310],
    [980, 160],
    [980, 120],
    [728, 90],
    [2, 1],
  ],
  rectangle1: [
    [540, 776],
    [490, 600],
    [490, 400],
    [468, 672],
    [468, 600],
    [468, 400],
    [468, 192],
    [300, 300],
    [300, 250],
    [10, 1],
    [9, 1],
    [1, 1],
  ],
  rectangle1without1x1: [
    [490, 600],
    [490, 400],
    [468, 600],
    [468, 400],
    [468, 192],
    [300, 300],
    [300, 250],
    [9, 1],
  ],
  rectangle2: [
    // NOT IN USE!?
    [278, 281],
    [9, 2],
  ],
  rectangle3: [
    [320, 320],
    [320, 300],
    [300, 431],
    [300, 300],
    [300, 250],
    [2, 1],
    [1, 1],
  ],
  rectangle4: [
    [300, 600],
    [300, 431],
    [320, 320],
    [320, 300],
    [300, 300],
    [300, 250],
    [10, 1],
    [1, 1],
  ],
  rectangle5: [
    [300, 600],
    [300, 431],
    [300, 300],
    [300, 250],
    [1, 1],
  ],
  interstitial1: [
    [700, 1010],
    [7, 1],
  ],
  wallpaper: [
    [1600, 1200],
    [1, 1],
  ],
  skyscraper: [
    [140, 350],
    [160, 350],
    [160, 600],
    [3, 1],
  ],
};

const lazyloadSettings: { [key: string]: { top: number; bottom: number } } = {
  articleNative: {
    top: -150,
    bottom: 150,
  },
  parade7: {
    top: -150,
    bottom: 150,
  },
};

const placements: IPlacementsConfiguration<
  ICustomVariables,
  SiteNativeTemplate
> = {
  uutiset_desktop_wide: [
    {
      divId: "almad-wallpaper-1",
      placementId: 9796274,
      sizes: sizes.wallpaper,
      friendlyName: "dynaaminen tapetti",
    },
    {
      divId: "almad-interstitial-1",
      placementId: 9796227,
      sizes: sizes.interstitial1,
      lazyload: {
        disable: true,
      },
      friendlyName:
        "Kauppalehti.fi_avaussivu_700x1010_(interstitiaali - MUISTA LIST KAMPANJALLE FREKU! Yksinoikeu",
    },
    {
      divId: "almad-parade-1",
      placementId: 9796278,
      sizes: sizes.parade1,
      friendlyName: "jättibanneri, panorama, paraatipaikka,",
      prebid: {
        active: true,
        source: "Kauppalehti_Uutiset_NordicParade",
      },
    },
    {
      divId: "almad-widerectangle-1",
      placementId: 9797051,
      sizes: sizes.rectangle1,
      adType: ["banner", "native"],
      friendlyName:
        "Kauppalehti.fi_uutiset_300x250|468x400|490x400_(boksi, jttiboksi,tuplajttiboksi)",
      prebid: {
        active: true,
        source: "Kauppalehti_Uutiset_NordicGiantRectangle",
      },
      native: {
        template: "native_rectangle_orange",
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13918023,
      sizes: sizes.rectangle5,
      adType: ["banner", "native"],
      friendlyName: "uusi paikka",
      native: {
        template: "native_linkedin_ad",
      },
    },
    {
      divId: "almad-rectangle-2",
      placementId: 13976565,
      sizes: [
        [300, 300],
        [1, 1],
      ],
      friendlyName: "myyntiruutu, vaihda oikea id",
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9797042,
      sizes: sizes.skyscraper,
      friendlyName:
        "Kauppalehti.fi_uutiset_140x350|160x600_(suurtaulu, pidennetty suurtaulu)",
      prebid: {
        active: true,
        source: "Kauppalehti_Uutiset_WideSkyscraper",
      },
    },
  ],
  uutiset_artikkeli_desktop_wide: {
    source: "uutiset_desktop_wide",
    remove: ["almad-widerectangle-1"],
    add: [
      {
        divId: "almad-text-1",
        placementId: 13422824,
        sizes: [[300, 250]],
      },
      {
        divId: "almad-outstream-1",
        placementId: 11292097,
        sizes: [[1, 1]],
        adType: ["video", "banner"],
      },
      {
        divId: "almad-widerectangle-1",
        placementId: 9797051,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
        native: {
          template: "native_rectangle_orange",
        },
      },
      {
        divId: "almad-widerectangle-2",
        placementId: 9797051,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
        native: {
          template: "native_rectangle_orange",
        },
      },
      {
        divId: "almad-widerectangle-3",
        placementId: 17969295,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        friendlyName:
          "Kauppalehti.fi_uutiset_300x250|468x400|490x400_2_(volyymipaikka, jättiboksi)",
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
      },
      {
        divId: "almad-widerectangle-4",
        placementId: 17969295,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        friendlyName:
          "Kauppalehti.fi_uutiset_300x250|468x400|490x400_2_(volyymipaikka, jättiboksi)",
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
      },
      {
        divId: "almad-native-5",
        lazyload: {
          offset: { ...lazyloadSettings.articleNative },
        },
        placementId: 18639738,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi1",
      },
      {
        divId: "almad-native-6",
        lazyload: {
          offset: { ...lazyloadSettings.articleNative },
        },
        placementId: 18639739,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi2",
      },
    ],
  },
  uutiset_desktop: {
    source: "uutiset_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1"],
  },
  uutiset_artikkeli_desktop: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-widerectangle-1",
    ],
    add: [
      {
        divId: "almad-text-1",
        placementId: 13422824,
        sizes: [[300, 250]],
      },
      {
        divId: "almad-outstream-1",
        placementId: 11292097,
        sizes: [[1, 1]],
        adType: ["video", "banner"],
      },
      {
        divId: "almad-widerectangle-1",
        placementId: 9797051,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
        native: {
          template: "native_rectangle_orange",
        },
      },
      {
        divId: "almad-widerectangle-2",
        placementId: 9797051,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
        native: {
          template: "native_rectangle_orange",
        },
      },
      {
        divId: "almad-widerectangle-3",
        placementId: 17969295,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        friendlyName:
          "Kauppalehti.fi_uutiset_300x250|468x400|490x400_2_(volyymipaikka, jättiboksi)",
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
      },
      {
        divId: "almad-widerectangle-4",
        placementId: 17969295,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        friendlyName:
          "Kauppalehti.fi_uutiset_300x250|468x400|490x400_2_(volyymipaikka, jättiboksi)",
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
      },
      {
        divId: "almad-native-5",
        lazyload: {
          offset: { ...lazyloadSettings.articleNative },
        },
        placementId: 18639738,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi1",
      },
      {
        divId: "almad-native-6",
        lazyload: {
          offset: { ...lazyloadSettings.articleNative },
        },
        placementId: 18639739,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi2",
      },
    ],
  },
  uutiset_portable: {
    source: "uutiset_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-parade-1"],
    add: [
      {
        divId: "almad-parade-1",
        placementId: 9796401,
        sizes: sizes.rectangle3,
        adType: ["banner", "native"],
        native: {
          template: "native_linkedin_ad",
        },
      },
    ],
  },
  uutiset_artikkeli_portable: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-widerectangle-1",
      "almad-parade-1",
    ],
    add: [
      {
        divId: "almad-parade-1",
        placementId: 9796401,
        sizes: sizes.rectangle3,
        native: {
          template: "native_linkedin_ad",
        },
      },
      {
        divId: "almad-text-1",
        placementId: 13422824,
        sizes: [[300, 250]],
      },
      {
        divId: "almad-outstream-1",
        placementId: 11292097,
        sizes: [[1, 1]],
        adType: ["video", "banner"],
      },
      {
        divId: "almad-widerectangle-1",
        placementId: 9797051,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
        native: {
          template: "native_rectangle_orange",
        },
      },
      {
        divId: "almad-widerectangle-2",
        placementId: 9797051,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
        native: {
          template: "native_rectangle_orange",
        },
      },
      {
        divId: "almad-widerectangle-3",
        placementId: 17969295,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        friendlyName:
          "Kauppalehti.fi_uutiset_300x250|468x400|490x400_2_(volyymipaikka, jättiboksi)",
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
      },
      {
        divId: "almad-widerectangle-4",
        placementId: 17969295,
        sizes: sizes.rectangle1,
        adType: ["banner", "native"],
        friendlyName:
          "Kauppalehti.fi_uutiset_300x250|468x400|490x400_2_(volyymipaikka, jättiboksi)",
        prebid: {
          active: true,
          source: "Kauppalehti_Uutiset_NordicGiantRectangle",
        },
      },
      {
        divId: "almad-native-5",
        lazyload: {
          offset: { ...lazyloadSettings.articleNative },
        },
        placementId: 18639738,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi1",
      },
      {
        divId: "almad-native-6",
        lazyload: {
          offset: { ...lazyloadSettings.articleNative },
        },
        placementId: 18639739,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi2",
      },
    ],
  },
  uutiset_mobile: [
    {
      divId: "almad-interstitial-1",
      placementId: 9796395,
      sizes: sizes.interstitial1,
      lazyload: {
        disable: true,
      },
      friendlyName:
        "Kauppalehti.fi_avaussivu_700x1010_(interstitiaali - MUISTA LIST KAMPANJALLE FREKU! Yksinoikeu",
    },
    {
      divId: "almad-parade-1",
      placementId: 9796401,
      sizes: sizes.rectangle3,
      adType: ["banner", "native"],
      friendlyName: "",
      native: {
        template: "native_linkedin_ad",
      },
    },
    {
      divId: "almad-parade-2",
      placementId: 9796399,
      sizes: sizes.rectangle4,
      adType: ["banner", "native"],
      friendlyName: "",
      native: {
        templateSelector: (
          c: StackContext,
          adObject: IXandrNativeAdObject
        ): SiteNativeTemplate => {
          if (nativeLinkedInConditions(adObject)) {
            return "native_linkedin_ad";
          }
          return "native_rectangle_orange";
        },
      },
    },
    {
      divId: "almad-parade-7",
      lazyload: {
        offset: { ...lazyloadSettings.articleNative },
      },
      placementId: 9796404,
      sizes: sizes.rectangle4,
      friendlyName: "house",
    },
  ],
  uutiset_artikkeli_mobile: {
    source: "uutiset_mobile",
    add: [
      {
        divId: "almad-text-1",
        placementId: 13422824,
        sizes: [[300, 250]],
      },
      {
        divId: "almad-outstream-1",
        placementId: 11292098,
        sizes: [[1, 1]],
        adType: ["video", "banner"],
      },
      {
        divId: "almad-parade-3",
        placementId: 9796399,
        sizes: sizes.rectangle4,
        friendlyName: "",
        native: {
          templateSelector: (
            c: StackContext,
            adObject: IXandrNativeAdObject
          ): SiteNativeTemplate => {
            if (nativeLinkedInConditions(adObject)) {
              return "native_linkedin_ad";
            }
            return "native_rectangle_orange";
          },
        },
      },
      {
        divId: "almad-parade-4",
        placementId: 9796399,
        sizes: sizes.rectangle4,
        friendlyName: "",
        native: {
          templateSelector: (
            c: StackContext,
            adObject: IXandrNativeAdObject
          ): SiteNativeTemplate => {
            if (nativeLinkedInConditions(adObject)) {
              return "native_linkedin_ad";
            }
            return "native_rectangle_orange";
          },
        },
      },
      {
        divId: "almad-parade-5",
        placementId: 17969325,
        sizes: sizes.rectangle4,
        friendlyName: "Kauppalehti.fi_uutiset_300x300_2_mobile_(volyymipaikka)",
      },
      {
        divId: "almad-parade-6",
        placementId: 17969325,
        sizes: sizes.rectangle4,
        friendlyName: "Kauppalehti.fi_uutiset_300x300_2_mobile_(volyymipaikka)",
      },
      {
        divId: "almad-native-5",
        lazyload: {
          disable: true,
        },
        placementId: 18639738,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi1",
      },
      {
        divId: "almad-native-6",
        lazyload: {
          offset: { ...lazyloadSettings.articleNative },
        },
        placementId: 18639739,
        sizes: [[1, 1]],
        adType: ["banner", "native"],
        friendlyName: "Kauppalehti.fi_artikkelit_natiivi2",
      },
    ],
  },
  tyopaikat_desktop_wide: {
    source: "uutiset_desktop_wide",
    remove: ["almad-widerectangle-1", "almad-widerectangle-1", "almad-rectangle-2"],
    add: [
      {
        divId: "almad-native-1",
        placementId: 9797051,
        sizes: [
          [1, 1],
        ],
        adType: ["native"],
        native: {
          template: "native_rectangle_orange",
        },
      },
    ],
  },
  tyopaikat_desktop: {
    source: "uutiset_desktop_wide",
    remove: ["almad-wallpaper-1", "almad-skyscraper-1", "almad-widerectangle-1", "almad-widerectangle-1", "almad-rectangle-2"],
    add: [
      {
        divId: "almad-native-1",
        placementId: 9797051,
        sizes: [
          [1, 1],
        ],
        adType: ["native"],
        native: {
          template: "native_rectangle_orange",
        },
      },
    ],
  },
  tyopaikat_portable: {
    source: "uutiset_desktop_wide",
    remove: ["almad-parade-1", "almad-wallpaper-1", "almad-skyscraper-1", "almad-widerectangle-1", "almad-widerectangle-1", "almad-rectangle-2"],
    add: [
      {
        divId: "almad-native-1",
        placementId: 9797051,
        sizes: [
          [1, 1],
        ],
        adType: ["native"],
        native: {
          template: "native_rectangle_orange",
        },
      },
      {
        divId: "almad-parade-1",
        placementId: 9796401,
        sizes: sizes.rectangle3,
        adType: ["banner", "native"],
        native: {
          template: "native_linkedin_ad",
        },
      },
    ],
  },
  tyopaikat_mobile: [
    {
      divId: "almad-interstitial-1",
      placementId: 9796395,
      sizes: sizes.interstitial1,
      lazyload: {
        disable: true,
      },
      friendlyName:
        "Kauppalehti.fi_avaussivu_700x1010_(interstitiaali - MUISTA LIST KAMPANJALLE FREKU! Yksinoikeu",
    },
    {
      divId: "almad-parade-1",
      placementId: 9796401,
      sizes: sizes.rectangle3,
      adType: ["banner", "native"],
      friendlyName: "",
      native: {
        template: "native_linkedin_ad",
      },
    },
    {
      divId: "almad-parade-2",
      placementId: 9796399,
      sizes: sizes.rectangle4,
      adType: ["banner", "native"],
      friendlyName: "",
      native: {
        templateSelector: (
          c: StackContext,
          adObject: IXandrNativeAdObject
        ): SiteNativeTemplate => {
          if (nativeLinkedInConditions(adObject)) {
            return "native_linkedin_ad";
          }
          return "native_rectangle_orange";
        },
      },
    },
    {
      divId: "almad-native-1",
      placementId: 9797051,
      sizes: [
        [1, 1],
      ],
      adType: ["native"],
      native: {
        template: "native_rectangle_orange",
      },
    },
    {
      divId: "almad-parade-7",
      lazyload: {
        offset: { ...lazyloadSettings.articleNative },
      },
      placementId: 9796404,
      sizes: sizes.rectangle4,
      friendlyName: "house",
    },
  ],

  
  yritykset_desktop_wide: [
    {
      divId: "almad-wallpaper-1",
      placementId: 9797063,
      sizes: sizes.wallpaper,
      friendlyName: "dynaaminen tapetti",
    },
    {
      divId: "almad-parade-1",
      placementId: 9796280,
      sizes: sizes.parade1,
      friendlyName: "jättibanneri, panorama, paraatipaikka,",
      prebid: {
        active: true,
        source: "Kauppalehti_Uutiset_NordicParade",
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13995006,
      sizes: sizes.rectangle5,
      friendlyName: "uusi paikka",
    },
    {
      divId: "almad-skyscraper-1",
      placementId: 9797062,
      sizes: sizes.skyscraper,
      friendlyName:
        "Kauppalehti.fi_uutiset_140x350|160x600_(suurtaulu, pidennetty suurtaulu)",
      prebid: {
        active: true,
        source: "Kauppalehti_Uutiset_WideSkyscraper",
      },
    },
  ],
  yritykset_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 9796280,
      sizes: sizes.parade1,
      friendlyName: "jättibanneri, panorama, paraatipaikka,",
      prebid: {
        active: true,
        source: "Kauppalehti_Uutiset_NordicParade",
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13995006,
      sizes: sizes.rectangle5,
      friendlyName: "uusi paikka",
    },
  ],
  yritykset_portable: [
    {
      divId: "almad-parade-1",
      placementId: 13975964,
      sizes: sizes.rectangle3,
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13995006,
      sizes: sizes.rectangle4,
      friendlyName: "uusi paikka",
    },
  ],
  yritykset_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 13975964,
      sizes: sizes.rectangle3,
    },
  ],
  kaupallinen_yhteistyo_desktop_wide: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-interstitial-1",
      "almad-outstream-1",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-3",
      "almad-widerectangle-4",
    ],
    add: [
      {
        divId: "almad-sima-1",
        placementId: 19218765,
        friendlyName: "Kauppalehti_SIMA_1x1",
        sizes: [[1, 1]],
      },
    ],
  },
  kaupallinen_yhteistyo_desktop: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-interstitial-1",
      "almad-outstream-1",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-3",
      "almad-widerectangle-4",
      "almad-wallpaper-1",
      "almad-skyscraper-1",
    ],
    add: [
      {
        divId: "almad-sima-1",
        placementId: 19218765,
        friendlyName: "Kauppalehti_SIMA_1x1",
        sizes: [[1, 1]],
      },
    ],
  },
  kaupallinen_yhteistyo_portable: {
    source: "uutiset_desktop_wide",
    remove: [
      "almad-interstitial-1",
      "almad-outstream-1",
      "almad-widerectangle-1",
      "almad-widerectangle-2",
      "almad-widerectangle-3",
      "almad-widerectangle-4",
      "almad-wallpaper-1",
      "almad-skyscraper-1",
      "almad-parade-1",
    ],
    add: [
      {
        divId: "almad-sima-1",
        placementId: 19218765,
        friendlyName: "Kauppalehti_SIMA_1x1",
        sizes: [[1, 1]],
      },
    ],
  },
  kaupallinen_yhteistyo_mobile: {
    source: "uutiset_mobile",
    remove: ["almad-interstitial-1", "almad-outstream-1"],
    add: [
      {
        divId: "almad-sima-1",
        placementId: 19218765,
        friendlyName: "Kauppalehti_SIMA_1x1",
        sizes: [[1, 1]],
      },
    ],
  },
};

export default placements;
